import React from "react";
import {
  Field as StyledField,
  FieldLabel,
  Input,
  InputWrapper,
  InputRight,
} from "../styles";

const Field = ({
  label,
  value,
  onChange,
  type = "text",
  placeholder,
  right,
  disabled,
}) => {
  return (
    <StyledField>
      <FieldLabel>{label}</FieldLabel>
      <InputWrapper>
        <Input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          type={type}
          placeholder={placeholder}
          disabled={disabled}
          hasRight={!!right}
        />
        {right && <InputRight>{right}</InputRight>}
      </InputWrapper>
    </StyledField>
  );
};

export default Field;
